import _extends from "@babel/runtime/helpers/esm/extends";
import { useMemo } from 'react';
import { concat, reduce } from 'lodash';
import { useAxiosClient } from '../hooks';
import { createQueryKey, sanitizeParams } from '../utils';
import useInfiniteQuery from './useInfiniteQuery';
export default function usePagination(variant, basePath, params, options) {
  const axiosClient = useAxiosClient();
  const url = variant.replace('{basePath}', basePath);
  async function queryFn(page) {
    const response = await axiosClient.get(url, {
      params: _extends({
        page
      }, sanitizeParams(params))
    });
    return response.data;
  }
  const queryKey = createQueryKey(basePath, variant, params);
  const query = useInfiniteQuery(queryKey, ({
    pageParam = 1
  }) => queryFn(pageParam), _extends({
    getNextPageParam: (lastPage, allPages) => {
      if (lastPage.response.length < params.limit) {
        return undefined;
      }
      return allPages.length + 1;
    }
  }, options));
  const allItems = useMemo(() => {
    var _query$data;
    return reduce((_query$data = query.data) == null ? void 0 : _query$data.pages, (result, page) => concat(result, page.response), []);
  }, [query.data]);
  return _extends({}, query, {
    allItems
  });
}